import DatePicker from "components/app/function/DatePicker";

import { Textarea } from "components/ui/textarea";

const ChangeDOApplicationForm = ({ employeeInitRequest, handleChangeDoRequest, changeDoApplicationFrom, setValuesRemarkChangeDo }: any) => {
  return (
    <>
      <div>
        <h4 className="text-xl font-semibold text-blue-600 mb-2">Change Day Off Detail</h4>
        <div>
          <label>Working Date (OFF)</label>
          <div className="grid  grid-cols-5 gap-2 mt-2">
            <DatePicker
              disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
              className="py-3 h-[45px] text-[15px] border border-gray-300"
              value={changeDoApplicationFrom.working_date}
              onChange={(e) => {
                handleChangeDoRequest("working_date", e);
              }}
            />
          </div>
        </div>
      </div>

      <div>
        <label> Reason </label>
        <Textarea
          disabled={employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved"}
          className="text-[15px] focus:border-none focus:border-1 mt-2"
          value={changeDoApplicationFrom.remark}
          onChange={(e) => {
            handleChangeDoRequest("remark", e.target.value);
            setValuesRemarkChangeDo(e.target.value);
          }}
          rows={4}
        />
      </div>
    </>
  );
};

export default ChangeDOApplicationForm;
